var njmClientClickTracking = function () {
    function sendTrackingInfo(objParam, methodName) {
        return new Promise((resolve, reject) => {
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (xhttp.readyState === 4) { // Ensure the request has completed
                    if (xhttp.status === 200) {
                        resolve(xhttp.responseText);
                    } else {
                        reject('Status: ' + this.status + '\nHeaders: ' + JSON.stringify(this.getAllResponseHeaders()) + '\nBody: ' + this.responseText);
                    }
                }
            };
            var forgeryId = document.getElementsByName("__RequestVerificationToken")[0].value;
            xhttp.open("POST", "/njm/CustomAnalyticsService/" + methodName, false);
            xhttp.setRequestHeader("Content-type", "application/json");
            xhttp.setRequestHeader("VerificationToken", forgeryId);
            var json = JSON.stringify(objParam);
            xhttp.send(json);
        });
    };

    return {
        linkClicked: function (objParam) {
            var jsonData = { name: "Link Clicked", data: objParam.innerText, text: objParam.id };
            sendTrackingInfo(jsonData, "TrackEvent");
        },
        quoteLinkClicked: function (EventName, Data, text) {
            //var jsonData = { name: "Quote Link Clicked", data: JSON.stringify({ EventName: EventName, Data: Data, PageUrl: window.location.href }), text: text };
            //sendTrackingInfo(jsonData, "TrackEvent");
        },
        linkClickedWithUserID: function (objParam, UserId) {
            var jsonData = { name: "Link Clicked", data: JSON.stringify({ EventName: objParam.innerText, Userid: UserId }), text: objParam.id };
            sendTrackingInfo(jsonData, "TrackEvent");
        },
        screenLoadingsuccessful: function (ScreenName, UserId) {
            var jsonData = { name: "Link Clicked", data: JSON.stringify({ EventName: "securityqp", Userid: UserId }), text: ScreenName + "Display Successful" };
            sendTrackingInfo(jsonData, "TrackEvent");
        },
        trackRedirects: function (CurrentPage, UrlReferrer, RedirectingTo) {
            var jsonData = { name: "Redirecting", data: JSON.stringify({ EventName: "Page Redirect", UrlReferrer: UrlReferrer, RedirectingTo: RedirectingTo }), text: CurrentPage };
            sendTrackingInfo(jsonData, "TrackEvent");
        },
        logError: function (objParam) {
            var jsonData = { name: "Error", data: objParam.innerText, text: objParam.id };
            sendTrackingInfo(jsonData, "TrackEvent");
        },
        logErrorGeneric: function (methodName, errorMessage, statusCode, userId, exception) {
            var jsonData = { name: "Error", data: JSON.stringify({ MethodName: methodName, StatusCode: statusCode, UserId: userId, Exception: exception }), text: errorMessage };
            sendTrackingInfo(jsonData, "TrackEvent");
        },
        trackUser: async function (objParam, pUserid, pPolicyType) {
            var jsonData = { name: "update profile", data: JSON.stringify({ Userid: pUserid, PolicyTypes: pPolicyType }), text: objParam.id };
            try {
                await sendTrackingInfo(jsonData, "TrackUser");
                console.log('Tracking info sent successfully.');
            } catch (error) {
                console.error('Error sending tracking info: ', error);
            }
        },
        trackPageName: function (pageUrl, referralUrl) {
            var jsonData = { pageurl: pageUrl, referralurl: referralUrl };
            sendTrackingInfo(jsonData, "TrackPage");
        },
        triggerGoal: function (goalid) {
            var jsonData = { goalId: goalid };
            sendTrackingInfo(jsonData, "TriggerGoal");
        }
    }
}();
